/**
 * Hilfsfunktionen für den Facebook Pixel im Frontend
 */

// Pixel-ID
const PIXEL_ID = '1048497165333604';

/**
 * Initialisiert den Facebook Pixel
 */
export const initFacebookPixel = () => {
  if (window.fbq) return;
  
  // Facebook Pixel Base Code
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  
  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');
  /* eslint-enable */
  
  // Debug-Informationen
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Facebook Pixel] Initialized with ID: ${PIXEL_ID}`);
  }
};

/**
 * Sendet ein PageView-Event an den Facebook Pixel
 */
export const trackPageView = () => {
  if (!window.fbq) {
    console.warn('[Facebook Pixel] fbq not initialized yet');
    return;
  }
  
  window.fbq('track', 'PageView');
  
  if (process.env.NODE_ENV === 'development') {
    console.log('[Facebook Pixel] PageView event sent');
  }
};

/**
 * Sendet ein AddToCart-Event an den Facebook Pixel (für Unternehmenssuche)
 * @param {Object} businessDetails - Die Unternehmensdetails
 * @param {string} keyword - Der Suchbegriff
 */
export const trackAddToCart = (businessDetails, keyword) => {
  if (!window.fbq) {
    console.warn('[Facebook Pixel] fbq not initialized yet');
    return;
  }
  
  const eventData = {
    content_type: 'product',
    content_name: 'Google Rank Check',
    content_category: 'Local SEO',
    currency: 'EUR',
    value: 0.0,
    business_name: businessDetails?.name || '',
    business_category: (businessDetails?.types && businessDetails.types[0]) || '',
    keyword: keyword || '',
  };
  
  window.fbq('track', 'AddToCart', eventData);
  
  if (process.env.NODE_ENV === 'development') {
    console.log('[Facebook Pixel] AddToCart event sent', eventData);
  }
};

/**
 * Sendet ein Lead-Event an den Facebook Pixel (für Kontaktformular)
 * @param {Object} businessDetails - Die Unternehmensdetails
 * @param {string} keyword - Der Suchbegriff
 * @param {Object} contactData - Die Kontaktdaten
 */
export const trackLead = (businessDetails, keyword, contactData) => {
  if (!window.fbq) {
    console.warn('[Facebook Pixel] fbq not initialized yet');
    return;
  }
  
  const eventData = {
    content_name: 'Google Rank Lead',
    content_category: 'Local SEO Lead',
    currency: 'EUR',
    value: 10.0,
    business_name: businessDetails?.name || '',
    business_category: (businessDetails?.types && businessDetails.types[0]) || '',
    keyword: keyword || '',
  };
  
  window.fbq('track', 'Lead', eventData);
  
  if (process.env.NODE_ENV === 'development') {
    console.log('[Facebook Pixel] Lead event sent', eventData);
  }
};

export default {
  initFacebookPixel,
  trackPageView,
  trackAddToCart,
  trackLead
};